export class SecretService {
  user1: string;
  user2: string;
  password: string;
  constructor() {
    this.user1 = "27753208@APPLE";
    this.user2 = "27753207@APPLE";
    this.password = "pq4j9W95";
  }
}


// csc:1000:74bd30bfbbca97bbb6aa84db016c4ff2@GOOGLE
// csc:1001:e8e4b0b23a5c75a09f95a6ab40bb2309@GOOGLE
export class SecretService2 {
  user1: string;
  user2: string;
  password1: string;
  password2: string;
  constructor() {
    this.user1 = "1000@GOOGLE";
    this.user2 = "1001@GOOGLE";
    this.password1 = "74bd30bfbbca97bbb6aa84db016c4ff2";
    this.password2 = "e8e4b0b23a5c75a09f95a6ab40bb2309";
  }
}
